import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'tanok';
import { getRoom } from '@evo/chat-core';
import { t, ngettext, msgid } from 'c-3po';
import { toJS } from '../../../helpers/ImmutableToJS';
import * as a from './../../../../libs/actions';
import * as c from './../../../../libs/constants';
import { getResponseMedianText } from '../../../../libs/helpers/prom';
import { getSocketStore, sanitizeLocation } from './../../../../libs/utils';

import { Notice } from '../../../ui/notice';
import { Button } from '../../../ui/button';
import { Icon } from '../../../ui/icon';

// styles
import css from './companyBody.sss';

// images
import ErrorNoticePng from './images/errorNotice.png';
import PhoneIconSvg from './images/phone.icon.svg';
import WorldIconSvg from './images/world.icon.svg';


class BodyView extends React.Component {
    static propTypes = {
        responseMedian: PropTypes.any,
        notification: PropTypes.object,
        companyInfo: PropTypes.object,
        companyBanId: PropTypes.any,
        modifiedCompanyRoom: PropTypes.object,
    };

    handleProceedTab = () => {
        const isBannedCompany = this.props.modifiedCompanyRoom.companyBanned;
        this.props.send(a.EVENT_COMPANY_CHANGE_TAB,
            { tabName: !isBannedCompany ? c.CHAT_COMPANY_BAN : c.CHAT_COMPANY_UNBAN });
    }

    render() {
        const { companyInfo, notification, modifiedCompanyRoom, responseMedian } = this.props;

        const opinionCountText = companyInfo.opinionsTotal
            ? `${ngettext(msgid`отзыв`, `отзыва`, `отзывов`, companyInfo.opinionsTotal)}`
            : '';

        if (notification.error === c.NOTIFICATION_ERROR_COMPANY_INFO) {
            return (
                <Notice
                    image={ErrorNoticePng}
                    title={t`Что-то пошло не так...`}
                >
                    {t`При выполнении вашего запроса произошла внутренняя ошибка`}
                </Notice>
            );
        }

        return (
            <div className={css.root} data-qaid='company_info_block'>
                <div className={css.content}>
                    <div name='baseInfo' className={css.contentBlock}>
                        <div className={css.info}>
                            {companyInfo.logoImg && (
                                <div className={css.logoHolder}>
                                    <a
                                        href={companyInfo.absoluteUrl}
                                        target='_blank'
                                    >
                                        <img
                                            className={css.logoImage}
                                            src={companyInfo.logoImg}
                                            alt={modifiedCompanyRoom.extra.company_name}
                                        />
                                    </a>
                                </div>
                            )}
                            <a
                                className={css.companyName}
                                href={companyInfo.absoluteUrl}
                                target='_blank'
                            >
                                {modifiedCompanyRoom.room_name}
                            </a>
                            <div className={css.ratingHolder}>
                                {!companyInfo.opinionsTotal ? (
                                    <div className={css.ratingPlaceholder}>
                                        {t`Еще нет отзывов о этом продавце`}
                                    </div>
                                ) : (
                                    <a
                                        className={css.ratingWrapper}
                                        href={sanitizeLocation(this.props.companyInfo.opinionListUrl)}
                                        target='_blank'
                                    >
                                        <span className={css.ratingCount}>
                                            <span>
                                                <b>{companyInfo.opinionsTotal}</b><br />
                                                <span className={css.ratingCaption}>{opinionCountText}</span>
                                            </span>
                                        </span>
                                        <span className={css.ratingQuality}>
                                            <span>
                                                <b>{`${companyInfo.opinionQuality}%`}</b><br />
                                                <span className={css.ratingCaption}>{t`положительных`}</span>
                                            </span>
                                        </span>
                                    </a>
                                )}
                            </div>
                            <div name='opinionData'>
                                <a
                                    className={css.link}
                                    href={companyInfo.opinionCreateUrl}
                                    target='_blank'
                                    data-qaid='add_opinion_link'
                                >
                                    {t`Оставить отзыв`}
                                </a>
                            </div>
                            <ul name='Notes' className={css.stats}>
                                <li className={css.statsItem}>
                                    {t`${companyInfo.timeOnPortal} на портале`}
                                </li>
                                <li
                                    className={css.statsItem}
                                    dangerouslySetInnerHTML={{ __html: companyInfo.productText }}
                                />
                                {!!getResponseMedianText(responseMedian) && (
                                    <li className={css.statsItem}>
                                        {getResponseMedianText(responseMedian)}
                                    </li>
                                )}
                            </ul>
                            {companyInfo.isVerified && (
                                <ul className={css.labels}>
                                    <li className={css.labelItem}>
                                        <span>{t`Наличие документов`}</span>
                                    </li>
                                </ul>
                            )}
                        </div>
                    </div>
                    {(companyInfo.absoluteUrl || companyInfo.mainPhone) && (
                        <div className={css.contentBlock}>
                            {companyInfo.absoluteUrl && (
                                <div className={css.row}>
                                    <div className={css.iconHolder}>
                                        <Icon
                                            className={css.icon}
                                            glyph={WorldIconSvg}
                                        />
                                    </div>
                                    <div className={css.valueHolder}>
                                        <div className={css.valueLine}>
                                            <a
                                                className={css.link}
                                                href={companyInfo.absoluteUrl}
                                                target='_blank'
                                                data-qaid='company_site'
                                            >
                                                {companyInfo.absoluteUrl}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {companyInfo.mainPhone && (
                                <div name='contactData' className={css.row}>
                                    <div className={css.iconHolder}>
                                        <Icon
                                            className={css.icon}
                                            glyph={PhoneIconSvg}
                                        />
                                    </div>
                                    <div className={css.valueHolder}>
                                        <div className={css.valueLine}>
                                            <a
                                                href={`tel:${companyInfo.mainPhone}`}
                                                className={css.link}
                                                data-qaid='company_phone'
                                            >
                                                {companyInfo.mainPhone}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
                {!modifiedCompanyRoom.companyBanned && (
                    <div name='clientButtonSectionChat' className={css.footer}>
                        {companyInfo.portalProductsUrl && (
                            <a
                                className={css.footerLink}
                                href={companyInfo.portalProductsUrl}
                                target='_blank'
                                data-qaid='all_company_products'
                            >
                                {t`Все товары продавца`}
                            </a>
                        )}
                        <Button
                            onClick={this.handleProceedTab}
                            dataQa='ban_btn'
                        >
                            {t`Заблокировать`}
                        </Button>
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const socketStore = getSocketStore(state);
    const modifiedCompanyRoom = getRoom(socketStore, state.get('prevOpenedRoomIdent'));

    return {
        companyInfo: state.get('companyInfo'),
        companyBanId: state.get('companyBanId'),
        notification: state.get('notification'),
        responseMedian: modifiedCompanyRoom.get('response_median') || '',
        locale: state.get('locale'),
        modifiedCompanyRoom,
    };
};

export const Body = connect(mapStateToProps)(toJS(BodyView));
